(ns common.schema.entities.counterparty-diligence.templates.notifications-registry
  "Maps a tenant to the set of counterparty-diligence notifications available
   for that tenant. Mirrors the structure of `templates/registry.cljc` for
   form templates — each tenant has its own developer-controlled notification
   defs in code, and admins configure recipients via the settings UI."
  (:require
   [common.schema.entities.counterparty-diligence.templates.capman.notifications
    :as capman-notifications]
   [common.util :as cu]))

(defn notifications-for-tenant
  "Return the vector of notification defs available for `tenant`.
   Returns an empty vector if the tenant has no configured notifications."
  [tenant]
  (cond
    (-> tenant :tenant/name (= "CapMan"))
    capman-notifications/all-notifications

    :else
    []))

(defn lookup
  "Return the notification def for `notification-id` within `tenant`'s
   available notifications, or nil."
  [tenant notification-id]
  (->> (notifications-for-tenant tenant)
       (cu/find-first-by :id notification-id)))
